import { useEffect, useRef, useState } from 'react';

const STATEMENT = [
  'We', 'are', 'feral.', '|',
  'Eight', 'specialists,', 'one', 'kennel,', '|',
  'AI-augmented,', 'production-tested,', '|',
  'shipping', 'in', 'days', 'what', 'agencies', 'take', 'months.', '|',
  'No', 'pitch', 'decks.', 'No', 'scope', 'creep.', '|',
  'Just', 'the', 'sharpest', 'pixels', 'and', 'the', 'fastest', 'bytes', '|',
  'in', 'every', 'product', 'we', 'touch.',
];

const Manifesto = () => {
  const sectionRef = useRef(null);
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const section = sectionRef.current;
    if (!section) return undefined;
    const onScroll = () => {
      const rect = section.getBoundingClientRect();
      const vh = window.innerHeight;
      const total = rect.height - vh;
      if (total <= 0) {
        setProgress(rect.top < 0 ? 1 : 0);
        return;
      }
      const seen = -rect.top;
      setProgress(Math.max(0, Math.min(1, seen / total)));
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const words = STATEMENT.filter((w) => w !== '|');
  const breakAt = new Set();
  let count = 0;
  STATEMENT.forEach((w) => {
    if (w === '|') breakAt.add(count);
    else count += 1;
  });

  return (
    <section ref={sectionRef} className="r-section manifesto" id="manifesto" aria-label="Manifesto">
      <div className="manifesto-track">
        <div className="manifesto-sticky">
          <div className="r-wrap">
            <div className="r-tag r-reveal">Manifesto</div>
            <p className="manifesto-text">
              {words.map((w, i) => {
                const lit = i / words.length <= progress + 0.02;
                const breakAfter = breakAt.has(i + 1);
                return (
                  <span key={`${w}-${i}`}>
                    <span className={`mf-word ${lit ? 'is-lit' : ''}`}>{w} </span>
                    {breakAfter && <br />}
                  </span>
                );
              })}
            </p>
            <div className="manifesto-sig r-reveal r-d2">— the kennel</div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Manifesto;
